import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useLang } from '../i18n';

export const PriceOnRequest = ({ compact = false, showCta = false, onClick, to, ctaLabel, testid = 'price-on-request', basePrice = null, currency = 'EUR' }) => {
  const { t, lang } = useLang();
  const hasBasePrice = Number.isFinite(Number(basePrice)) && Number(basePrice) > 0;
  const formattedPrice = hasBasePrice ? new Intl.NumberFormat(lang, { style: 'currency', currency, maximumFractionDigits: 0 }).format(Number(basePrice)) : '';
  return (
    <div data-testid={testid} className={compact ? 'eco-price-state-compact' : 'eco-price-state'}>
      {!hasBasePrice && <p className="eco-price-label">{t('price.label')}</p>}
      <p className={`eco-price-value ${compact ? 'text-lg' : ''}`}>{hasBasePrice ? t('price.fromPerson', { price: formattedPrice }) : t('price.onrequest')}</p>
      <p className={`${compact ? 'mt-1 text-xs' : 'mt-1 text-sm'} leading-[1.5] text-eco-ink/55`}>{hasBasePrice ? t('price.simulationNote') : t('price.requestNote')}</p>
      {showCta && (
        <>
          {to ? (
            <Link to={to} data-testid={`${testid}-cta`} className="eco-btn-primary group mt-4 w-full justify-center">
              {ctaLabel || t('cta.availability')} <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          ) : (
            <button type="button" data-testid={`${testid}-cta`} onClick={onClick} className="eco-btn-primary group mt-4 w-full justify-center">
              {ctaLabel || t('cta.availability')} <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
            </button>
          )}
          <p className="mt-2.5 text-center text-xs text-eco-ink/50" data-testid={`${testid}-micro`}>{t('cta.request.micro')}</p>
        </>
      )}
    </div>
  );
};
